import styled from 'styled-components'

interface StyledComponentsProps {
  green?: boolean
}

export const SmallButton = styled.button`
  width: 40px;
  height: 40px;
  background-color: transparent;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  img {
    height: 10px;
  }
`

export const CloseButtonWrapper = styled.div``

export const BackButtonWrapper = styled.div``

export const SearchInputWrapper = styled.div`
  height: 56px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid #f3f4f7;
  margin-bottom: 8px;
`

export const SelectedItemsHeader = styled.div`
  height: 48px;
  width: 100%;
  padding: 13.5px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const SelectedItemsTitle = styled.span`
  color: #646877;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
`

export const ListContainer = styled.div`
  padding: 0 16px;
  height: 100%;
  .ant-list-empty-text {
    display: none;
  }
`
export const SelectedItems = styled.div``

export const ItemTitle = styled.span`
  color: #646877;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
`

export const ItemCount = styled.span<StyledComponentsProps>`
  transition: color 1s ease-out;
  color: ${({ green }) => (green ? '#1CB954' : '#646877')};
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
`
export const GreenCheckMark = styled.img`
  width: 16px;
  height: 10px;
  margin-right: 8px;
`

export const ItemTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`
export const ListedItems = styled.div`
  height: 100%;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`

export const ListedItemWrapper = styled.div`
  border-bottom: 1px solid #f3f4f7;
  margin-top: 8px;
  height: 48px;
  width: 100%;
  padding: 13.5px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
export const ButtonContainer = styled.div`
  position: fixed;
  bottom: 16px;
  right: 16px;
  button {
    display: flex;
    justify-content: center;
    gap: 8px;
    width: 101px;
  }
`
